import React from 'react';
import Image from 'next/image';
import styles from './OurValues.module.scss';
import Reveal from 'react-awesome-reveal';
import { flipFromLeft, flipFromRight } from '../Animation/Animation';
import { Typography } from '../Typography';

const OurValues = () => {
  const values = [
    'Precision over shortcuts',
    'Clarity over complexity',
    'Reliability over hype',
    'Long-term impact over quick wins',
  ];

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.leftSection}>
          <Reveal keyframes={flipFromLeft} duration={1000} delay={100} triggerOnce>
            <Typography variant="display-lg" as="h2" color="grayDark-50" weight="semibold" className={styles.heading}>
              Our Values
            </Typography>
            <ul className={styles.valuesList}>
              {values.map((value, index) => (
                <li key={index} className={styles.valueItem}>
                  <div className={styles.checkIcon}>
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_1856_33713)">
                        <path d="M8.7526 14L12.2526 17.5L19.2526 10.5M25.6693 14C25.6693 20.4434 20.4459 25.6667 14.0026 25.6667C7.55928 25.6667 2.33594 20.4434 2.33594 14C2.33594 7.55672 7.55928 2.33337 14.0026 2.33337C20.4459 2.33337 25.6693 7.55672 25.6693 14Z" stroke="#9E77ED" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_1856_33713">
                          <path d="M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <Typography variant="text-lg" color="grayDark-600" className={styles.valueText}>
                    {value}
                  </Typography>
                </li>
              ))}
            </ul>
            <Typography variant="text-lg" color="grayDark-600" className={styles.conclusion}>
              These values guide every product we build and every partnership we form.
            </Typography>
          </Reveal>
        </div>
        <div className={styles.rightSection}>
          <Reveal keyframes={flipFromRight} duration={1000} delay={200} triggerOnce>
            <div className={styles.imageWrapper}>
              <Image
                src="/about/our-values.jpg"
                alt="Our Values"
                width={1024}
                height={1024}
                layout="responsive"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
};

export default OurValues;

